export default String.raw`
.cart-container {
    .cart {
        padding: 32px;
        &__products {
            &-expanded {
                height: auto;
                overflow: auto;
                .cart-row {
                    padding-left: 20px;
                }
            }
        }
        &__options {
            &.third-step {
                grid-template-columns: 100%;
                .cart__summary {
                    grid-column: 1;
                    grid-row: 2;
                    display: flex;
                    flex-direction: column;
                    &-row:first-child {
                        padding-top: 24px;
                    }
                    &.cart-hide-summary {
                        .cart__summary-row:first-child {
                            display: flex;
                        }
                    }
                }
            }
        }
        &__order-button {
            max-width: 300px;
            align-self: center;
        }
        &.thank-you-content {
            padding: 48px 32px;
        }
    }
    .cart__second-step {
        flex-direction: column;
        align-items: center;
        .login-container {
            margin-right: 0;
            margin-bottom: 32px;
            max-width: 588px;
            width: 100%;
        }
    }
}

.cart-header {
    padding: 16px 32px;
    &__steps {
        grid-column: 2 / 4;
    }
}

.cart-footer {
    padding: 16px 32px 32px;
}

.cart-account-box {
    max-width: 588px;
    width: 100%;
    &__btn.secondary-btn {
        margin-top: 16px;
    }
}

.cart-data-section.last {
    border-bottom: 1px solid #D5D5D5;
}

.cart-row {
    display: grid;
    justify-content: space-between;
    align-items: start;
    grid-template-columns: 50% 20% 20% 10%;
    grid-template-rows: repeat(2, auto);
    padding: 16px 0;

    &__number, &__total-price, &__currency {
        display: none;
    }

    &__deposit-price {
        width: auto;
        text-align: right;
        padding-right: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .deposit {
            display: flex;
            gap: 4px;
            &__unit {
                display: flex;
                gap: 4px;
                margin-top: 2px;
                font-size: 12px;
                line-height: 16px;
            }
        }
    }

    &__product {
        width: 100%;
        grid-row: 1 / 3;
        grid-column: 1;

        .cart-additional-info__title {
            display: none;
        }
        
        &-info {
            .loyalty-info {
                display: flex;
                align-items: center;
                gap: 4px;
                svg {
                    fill: $primaryColorFont;
                }
            }
        }

        &-name {
            width: 90%;
        }
    }

    &__price {
        width: 100%;
        grid-row: 1;
        grid-column: 2;
        text-align: left;
        margin-bottom: 16px;
        .cart-small-price {
            font-size: 12px;
        }
        .cart-bold-price {
            font-weight: 600;
        }
    }

    &__quantity {
        width: 100%;
        grid-row: 2;
        grid-column: 2;
    }

    &__additional {
        grid-row: 1;
        grid-column: 3;
        margin-bottom: 16px;
        font-size: 12px;
    }

    &__value {
        width: 100%;
        grid-row: 2;
        grid-column: 3;
        text-align: left;
        .cart-small-price {
            font-size: 10px;
            font-weight: 500;
            color: #767676;
        }
        .cart-bold-price {
            font-weight: 500;
        }
    }

    &__options {
        width: 100%;
        grid-row: 1;
        grid-column: 4;
        & > * {
            display: none;
        }
        &-deleter {
            display: block;
        }
    }

    &.header-row {
        display: none;
    }

    &__expandable {
        display: none !important;
    }
}

.cart-additional-info {
    flex-direction: row;
    align-items: center;
    margin-right: 0;
    &__title {
        margin-right: 6px;
        margin-bottom: 0;
    }
}

.cart-addresses-list {
    &__item {
        &-columns {
            width: min-content;
        }
        &-text > div:first-child {
            margin-right: 0;
        }
    }
}

.thank-you {
    &__column {
        margin-bottom: 24px;
    }
}

.cart-hide-on-desktop {
    display: block;
}

span.cart-hide-on-desktop {
    display: inline-block;
}

.cart-hide-on-mobile {
    display: none;
}

.cart-recommendations {
    padding: 32px 0;
    &__title {
        padding: 0 32px;
    }
    &::after, &::before {
        width: 32px;
    }
}

.cart-recommendations-item {
    width: calc(100% / 3);
    &__slider-prev {
        left: 37px;
    }
    &__slider-next {
        right: 37px;
    }
}
`